import { Record } from 'immutable';
// TODO: remove these when gate is removed. CT-17901
const AgentStatus = Record({
  agentId: null,
  portalId: null,
  awayMode: null,
  updatedAt: null,
  updatedByAgentId: null
}, 'AgentStatus');
export default AgentStatus;